/*
 *  This code was originally in bm-experimental. It is intentionally written in JavaScript,
 *  as it was originally intended to be common code which could be shared with the Front End Framework.
 */
(function (window, angular) {
    'use strict';

    var TranslateUtils = (function() {
        var _$inject = ['$translate'];
        function TranslateUtils($translate) {

            this.getStringFunc = function(translationId, interpolateParams, errorFunc) {
                // NOTE: This code is to maintain compatibility with existing Web Practice code, as that was
                // the behavior of the TranslateUtils.getStringFunc function. Should we refactor?
                if(angular.isFunction(interpolateParams)) {
                    interpolateParams = interpolateParams();
                }
                var resolvedValue = '';

                // Converts a Promise<string> into a Function<string>, where
                // the function will return a blank string until the Promise
                // resolves, at which point it will return the resolved string value.
                $translate(translationId, interpolateParams).then(
                    function(value) {
                        resolvedValue = value;
                    }, errorFunc);

                return function() {
                    return resolvedValue;
                };
            };
        }

        TranslateUtils.$inject = _$inject;
        return TranslateUtils;
    }());

    // TODO: migrate to module 'fef' when submitting to the fef repo.
    angular.module('bmpTranslateUtils', ['pascalprecht.translate']).service(
        'bmpTranslateUtils', TranslateUtils);

}(window, window.angular));
